module.exports = __webpack_public_path__ + "media/configurations/SX-SO-bc4553f5.png";